import React from 'react';
import { Modal, Button, Row, Col, Table, Badge } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { Company } from '../../../features/companies/companiesService';
import { formatDate } from '../../../utils/dateUtils';
import { Icon } from '../../../components/common/Icon';

interface CompanyDetailModalProps {
  show: boolean;
  onHide: () => void;
  company: Company;
}

const CompanyDetailModal: React.FC<CompanyDetailModalProps> = ({ 
  show, 
  onHide, 
  company 
}) => {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Şirket Detayları</Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        <Row className="mb-4">
          <Col xs={12} md={8}>
            <h4>{company.company_name}</h4>
            <p className="text-muted mb-2">
              {company.company_type === 'agency' ? 'Ajans' : 'Müşteri'}
              {company.industry && ` • ${company.industry}`}
            </p>
            {company.description && <p>{company.description}</p>}
          </Col>
          <Col xs={12} md={4} className="text-md-end">
            <Badge bg={company.is_active ? 'success' : 'danger'}>
              {company.is_active ? 'Aktif' : 'Pasif'}
            </Badge>
          </Col>
        </Row>
        
        <Table striped bordered responsive>
          <tbody>
            {company.website && (
              <tr>
                <th style={{ width: '30%' }}>Website</th>
                <td>
                  <a href={company.website} target="_blank" rel="noopener noreferrer">
                    {company.website}
                  </a>
                </td>
              </tr>
            )}
            
            {company.email && (
              <tr>
                <th>E-posta</th>
                <td>
                  <a href={`mailto:${company.email}`}>{company.email}</a>
                </td>
              </tr>
            )}
            
            {company.phone && (
              <tr>
                <th>Telefon</th>
                <td>
                  <a href={`tel:${company.phone}`}>{company.phone}</a>
                </td>
              </tr>
            )}
            
            {company.address && (
              <tr>
                <th>Adres</th>
                <td>{company.address}</td>
              </tr>
            )}
            
            {(company.city || company.country) && (
              <tr>
                <th>Şehir/Ülke</th>
                <td>
                  {company.city && company.city}
                  {company.city && company.country && ', '}
                  {company.country && company.country}
                </td>
              </tr>
            )}
            
            {company.postal_code && (
              <tr>
                <th>Posta Kodu</th>
                <td>{company.postal_code}</td>
              </tr>
            )}
            
            {company.tax_id && (
              <tr>
                <th>Vergi No</th>
                <td>{company.tax_id}</td>
              </tr>
            )}
            
            {company.company_size && (
              <tr>
                <th>Şirket Büyüklüğü</th>
                <td>{company.company_size}</td>
              </tr>
            )}
            
            {company.annual_revenue && (
              <tr>
                <th>Yıllık Gelir</th>
                <td>{company.annual_revenue.toLocaleString('tr-TR')} ₺</td>
              </tr>
            )}
            
            {company.establishment_date && (
              <tr>
                <th>Kuruluş Tarihi</th>
                <td>{formatDate(company.establishment_date)}</td>
              </tr>
            )}
            
            <tr>
              <th>Oluşturulma Tarihi</th>
              <td>{formatDate(company.created_at)}</td>
            </tr>
            
            <tr>
              <th>Son Güncelleme</th>
              <td>{formatDate(company.updated_at)}</td>
            </tr>
          </tbody>
        </Table>
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          <Icon icon={FaTimes} /> Kapat
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CompanyDetailModal;